import ResponseHelper from './response-helper';

/**
 * Lib that manages communication with Vizzto server related to user's student data.
 * For when client provides courses.
 * Returns with `code = 0` are considered sucessfull.
 */

export default (axios) => ({
  /**
   * Gets the ranking of users for given course.
   * @param {String} distributorId
   * @param {String} userToken
   * @param {String|Number} contentId
   * @param {Number} pageNumber
   * @param {Number} pageSize
   * @param {Number} limit
   * @returns {Promise<{code: number, data: {total: number, users: [{score: number, name: string, publicProfile: string, photo: string, id: string, progressionRatio: number}]}, message: string}>|*}
   */
  getCourseRanking(
    distributorId,
    userToken,
    contentId,
    pageNumber,
    pageSize,
    limit
  ) {
    return axios({
      method: 'get',
      url: `gamifications/content/${contentId}/ranking?limit=${limit}`,
      headers: {
        utoken: userToken
      }
    })
      .then(function (response) {
        const data = response.data.map(({ percentage, ...args }) => ({
          percentage: percentage / 100,
          ...args
        }));

        return Promise.resolve({
          data,
          code: 0,
          message: ''
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
  },

  /**
   * Gets users' activity in given course.
   * @param {String} distributorId
   * @param {String} userToken
   * @param {String|Number} contentId
   * @param {Number} pageNumber
   * @param {Number} pageSize
   * @returns {Promise<{code: number, data: {total: number, activities: [{datetime: string, name: string, publicProfile: string, photo: string, description: string, id: string, points: number}]}, message: string}>|*}
   */
  getCourseActivities(
    distributorId,
    userToken,
    contentId,
    pageNumber,
    pageSize
  ) {
    return axios({
      method: 'get',
      url: `gamifications/content/${contentId}/activity`,
      headers: {
        utoken: userToken
      }
    })
      .then(function (response) {
        return Promise.resolve({
          data: response.data,
          code: 0,
          message: ''
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
  },

  /**
   * Gets current user's activities in given course.
   * @param {String} userToken
   * @param {String|Number} contentId
   * @returns {Promise<{code: number, data: {total: number, history: [{datetime: string, description: string, id: string, points: number}]}, message: string}>|*}
   */
  getScoreHistory(userToken, contentId) {
    return axios({
      method: 'get',
      url: `gamifications/content/${contentId}/evolution`,
      headers: {
        utoken: userToken
      }
    })
      .then((response) => ({
        data: response.data,
        code: 0,
        message: ''
      }))
      .catch((error) => Promise.reject(ResponseHelper.getErrorResponse(error)));
  },
  /**
   * Gets the performance of users for given course.
   * @param {String} distributorId
   * @param {String} userToken

   * @returns {Promise<{code: number,data: { generalRanking: number, totalOfHours: number,coursesInProgress: number, totalPoints: number, totalCertificates: number, completedCourses: number}, message: string }>|*}
   */
  getCoursePerformance(distributorId, userToken) {
    return axios({
      method: 'get',
      url: `gamifications/performance`,
      headers: {
        utoken: userToken
      }
    })
      .then(function (response) {
        return Promise.resolve({
          data: response.data,
          code: 0,
          message: ''
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
  },

  /**
   * Gets users' certificates in given course.
   * @param {String} distributorId
   * @param {String} userToken
   * @param {String|Number} contentId
   * @param {Number} pageNumber
   * @param {Number} pageSize
   * @returns {Promise<{code: number, data: {total: number, activities: [{datetime: string, name: string, publicProfile: string, photo: string, description: string, id: string, points: number}]}, message: string}>|*}
   */
  getCourseCertificates(
    distributorId,
    userToken,
    contentId,
    pageNumber,
    pageSize
  ) {
    return axios({
      method: 'get',
      url: `gamifications/content/${contentId}/activity`,
      headers: {
        utoken: userToken
      }
    })
      .then(function (response) {
        return Promise.resolve({
          data: response.data,
          code: 0,
          message: ''
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
  }
});
